export default __webpack_public_path__ + "static/media/smallLiane.1f43a043.png";